import useSession from 'components/auth/useSession'
import { isLotacao } from 'components/auth/useSessionUtils'

export function useSessionHasConselhoClasse(): boolean {
  const { data: session } = useSession({ fetchPolicy: 'cache-only' })

  return isLotacao(session.acesso) && !!session.profissional?.numeroConselhoClasse
}
